export const tspayLimit = 50000; // Limite importo di pagamento con tspay

export const accountsExample = {
  accounts: [
    {
      accountId: "a5ea2b26-5b2f-4d6e-9f0d-9633515cdce1",
      resourceId: "0889901X60-K0889952800000000007542-0002-EUR",
      iban: "IT02K0889952800000000007542",
      currency: "EUR",
      providerId: "CBI-08899",
      bankName: "CR BCC DI TREVIGLIO",
      productCode: "RELAX",
      lastBalance: { amount: "-10866389", currency: "EUR" },
      lastBalanceDate: "2020-12-17",
      accountNature: "account",
      consentId: "a07dec8b-c328-400c-a918-0b46d6d3a2d7",
      consentExpireDate: "2021-03-17",
      lastRefreshStatus: "updated",
      lastRefreshDate: "2020-12-17T16:14:21.137+01:00"
    },
    {
      accountId: "a5ea2b26-5b2f-4d6e-9f0d-9633515cdce2",
      resourceId: "0889901X60-K0889952800000000007542-0003-EUR",
      iban: "IT02K0889952800000000007543",
      currency: "EUR",
      providerId: "CBI-08898",
      bankName: "UNICREDIT",
      productCode: "RELAX",
      lastBalance: { amount: "7050000700", currency: "EUR" },
      lastBalanceDate: "2020-12-17",
      accountNature: "account",
      consentId: "a07dec8b-c328-400c-a918-0b46d6d3a2d7",
      consentExpireDate: "2021-03-17",
      lastRefreshStatus: "updated",
      lastRefreshDate: "2020-12-17T16:14:21.137+01:00"
    }
  ]
};
